import { createAction, props } from "@ngrx/store";
import { landingpage } from "../model/landingpage";


export const loadLandingPage=createAction("[load Landing Page]",props<{landingpage:landingpage}>());
export const saveLandingpage=createAction("[save Landing Page]",props<{landingpage:landingpage}>());
export const landingpageFailure=createAction("[error Landing page]",props<{error:String}>())

export const viewLoadLandingPage=createAction("[Load Landingpage]");
export const viewSuccessLandingpage=createAction("[View Landing Page Success]",props<{landingpage:landingpage[]}>());
export const landingpageViewFailure=createAction("[error Landing page View]",props<{error:String}>())
